import React, { useState } from 'react';
import logo from "../../media/logo.svg";
import closeIcon from "../../media/icons/close.svg";
import { Link } from "react-router";
import { EServicesNames } from "../services/const.ts";
import { useTranslation } from 'react-i18next';


const MobileNav = ({ mobileNavIsOpened, setMobileNavIsOpened, classes }) => {
    const { t } = useTranslation();
    const [openMenu, setOpenMenu] = useState(null);
    const [openSubMenu, setOpenSubMenu] = useState(null);


    const mobileLinks = 
        [
            {
                name: t('header.companyTitle'),
                subLinks: t('header.companyLinksMobile', {returnObjects: true}),
            },
            {
                name: t('header.service.title'),
                subLinks: [
                    {
                        name: t('header.service.dropdownLeft.0.title'),
                        subLinks: [
                            { name: t('header.service.dropdownRight.it-consulting.0.title'), link: '/services/strategic-it-consulting' },
                        ],
                    },
                    {
                        name: t('header.service.dropdownLeft.1.title'),
                        subLinks: [
                            { name: t('header.service.dropdownRight.software-development.0.title'), link: `/services/${EServicesNames.SOFTWARE_DEVELOPMENT_SERVICES}` },
                            { name: t('header.service.dropdownRight.software-development.1.title'), link: `/services/${EServicesNames.ERP}` },
                            { name: t('header.service.dropdownRight.software-development.2.title'), link: `/services/${EServicesNames.CRM}` },
                        ],
                    },
                    {
                        name: t('header.service.dropdownLeft.2.title'),
                        subLinks: [
                            { name: t('header.service.dropdownRight.implementation-support.0.title'), link: `/services/${EServicesNames.SUPPORT}` },
                        ],
                    },
                    {
                        name: t('header.service.dropdownLeft.3.title'),
                        subLinks: [
                            { name: t('header.service.dropdownRight.startup-development.0.title'), link: '/services/startup-development' },
                        ],
                    },
                ],
            },
            {
                name: t('header.projectsTitle'),
                subLinks: [
                    { name: 'Cyber Tracker', link: '/case-study/cybertracker' },
                    { name: 'E-road', link: '/case-study/e-road' },
                    { name: 'E-Queue', link: '/case-study/e-cherha' },
                    { name: '1551', link: '/case-study/1551' },
                    { name: 'Syvi Project', link: '/case-study/syvi' },
                    { name: 'GoGoBag', link: '/case-study/go-go-bag' },
                ],
            },
            {
                name: t('header.industriesTitle'),
                subLinks: t('header.industriesLinksMobile', {returnObjects: true})
            },
            {
                name: t('header.solutionsTitle'),
                subLinks: t('header.solutionsLinksMobile', {returnObjects: true})
            },
            {
                name: t('header.blog'),
                link: '/blogs',
            },
        ];

    const toggleMenu = (index) => {
        setOpenMenu(openMenu === index ? null : index);
        setOpenSubMenu(null);
    };

    const toggleSubMenu = (index) => {
        setOpenSubMenu(openSubMenu === index ? null : index);
    };



    const closeAllMenus = () => {
        setOpenMenu(null);
        setOpenSubMenu(null);
        setMobileNavIsOpened(false);
    };

    if (!mobileNavIsOpened) return null;

    return (
        <div className={classes.container}>
            <div className={classes["mobile-nav-container"]}>

                <div className={classes['top-container']}>
                    <Link to={"/"} onClick={closeAllMenus}>
                        <img src={logo} alt="Logo" className={classes.logo}/>
                    </Link>

                    <button
                        className={classes["menu-button"]}
                        onClick={closeAllMenus}
                    >
                        <img src={closeIcon} alt="Close"/>
                    </button>
                </div>

                <div className={classes["navigation-links-container"]}>

                    {mobileLinks.map((link, index) => (
                        <div key={index} className={classes["nav-link-container"]}>

                            {link.subLinks ? (

                                <div
                                    className={classes["nav-link"]}
                                    onClick={() => toggleMenu(index)}
                                >
                                    <span className={classes['link-mobile']}>
                                        {link.name}
                                    </span>
                                </div>

                            ) : (

                                <Link
                                    to={link.link}
                                    className={classes['link-mobile']}
                                    onClick={closeAllMenus}
                                >
                                    {link.name}
                                </Link>

                            )}

                            {link.subLinks && openMenu === index && (

                                <div className={classes["sub-links-container"]}>

                                    {link.subLinks.map((subLink, subIndex) => (

                                        <div key={subIndex}>

                                            {subLink.subLinks ? (

                                                <div
                                                    className={`${classes.item} ${classes['link-mobile-2']}`}
                                                    onClick={() => toggleSubMenu(subIndex)}
                                                >
                                                    <span className={classes['link-mobile']}>
                                                        {subLink.name}
                                                    </span>
                                                </div>

                                            ) : (

                                                <Link
                                                    to={subLink.link}
                                                    className={`${classes['link-mobile']} ${classes['link-mobile-2']}`}
                                                    onClick={closeAllMenus}
                                                >
                                                    {subLink.name}
                                                </Link>

                                            )}

                                            {subLink.subLinks && openSubMenu === subIndex && (

                                                <div className={classes["nested-sub-links-container"]}>

                                                    {subLink.subLinks.map((nestedLink, nestedIndex) => (

                                                        <Link
                                                            key={nestedIndex}
                                                            to={nestedLink.link}
                                                            className={classes['link-mobile']}
                                                            onClick={closeAllMenus}
                                                        >
                                                            {nestedLink.name}
                                                        </Link>

                                                    ))}

                                                </div>

                                            )}

                                        </div>

                                    ))}

                                </div>

                            )}

                        </div>
                    ))}

                </div>
            </div>
        </div>
    );
};

export default MobileNav;